module.exports = __webpack_public_path__ + "02_short_gold.156ec1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_short_gold.png
// module id = ASrr
// module chunks = 0